import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle, BarChart3 } from 'lucide-react';
import { Button } from './ui/button';
import { trackCTAClick } from '../utils/analytics';

const FinalCTA = () => {
  const navigate = useNavigate();

  const scrollToConsultation = () => {
    trackCTAClick('Schedule a Leadership Strategy Session', 'final_cta');
    const element = document.querySelector('#consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToAssessment = () => {
    trackCTAClick('Get Your Free Alignment Score', 'final_cta');
    navigate('/assessment');
  };

  return (
    <section className="py-16 sm:py-24 bg-slate-950 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-violet-500/10 to-emerald-500/10" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
          Ready to Strengthen Your
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-violet-400 to-emerald-400">
            People and Performance?
          </span>
        </h2>

        <p className="text-slate-400 text-base sm:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          Whether you need leadership development, workforce training, team development, 
          or AI integration support—we can build a solution that fits your goals.
        </p>

        <div className="flex flex-col items-center gap-4">
          {/* Dual CTAs */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={goToAssessment}
              data-testid="final-assessment-cta"
              size="lg"
              className="bg-gradient-to-r from-violet-600 to-cyan-600 hover:from-violet-500 hover:to-cyan-500 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:shadow-xl hover:shadow-violet-500/20"
            >
              <BarChart3 className="mr-2 h-5 w-5" />
              Take the Free Assessment
            </Button>
            <Button
              onClick={scrollToConsultation}
              data-testid="final-cta-button"
              size="lg"
              variant="outline"
              className="border-white/20 text-white hover:bg-white/10 font-semibold px-8 py-6 text-lg backdrop-blur-sm"
            >
              Schedule a Strategy Session
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>

          {/* Micro Text */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-slate-400 text-sm">
            <span className="flex items-center gap-1.5">
              <CheckCircle className="h-4 w-4 text-emerald-400" />
              No cost consultation
            </span>
            <span className="flex items-center gap-1.5">
              <CheckCircle className="h-4 w-4 text-emerald-400" />
              Customized solutions
            </span>
            <span className="flex items-center gap-1.5">
              <CheckCircle className="h-4 w-4 text-emerald-400" />
              Funding may be available
            </span>
          </div>
        </div>

        {/* Trust Line */}
        <p className="text-slate-500 text-sm mt-8">
          Trusted by businesses, schools, agencies, and organizations across industries.
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
